import script from "./StatisticSignificance.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticSignificance.vue?vue&type=script&setup=true&lang=js"

import "./StatisticSignificance.vue?vue&type=style&index=0&id=6f411574&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f411574"]])

export default __exports__